module.exports = __webpack_public_path__ + "static/media/admin_user-groups.3f95ebfd.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/admin_user-groups.md
// module id = 1083
// module chunks = 0